module.exports = __webpack_public_path__ + "static/HorizontalPull-Row-cf0c0c303154fd981dda640f6eb240e6.mp4";